/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//react native imports
import { Dimensions } from 'react-native';

const Constants = {
  get DEBOUNCE_TIME() {
    const timeInSeconds = 0.6;
    const timeInMS = timeInSeconds * 1000;
    return timeInMS;
  },
  get SHOW_LOADER_DELAY() {
    const timeInSeconds = 1;
    const timeInMS = timeInSeconds * 1000;
    return timeInMS;
  },
  get TEXT_FIELD_HALF_WIDTH() {
    const screenWidth = Dimensions.get('screen').width;
    const spaceInBetween = 16 * 2 + 8;
    const textfieldWidth = (screenWidth - spaceInBetween) / 2;
    return textfieldWidth;
  },
  get TEXT_FIELD_FULL_WIDTH() {
    const screenWidth = Dimensions.get('screen').width;
    const spaceInBetween = 16 * 2;
    const textfieldWidth = screenWidth - spaceInBetween;
    return textfieldWidth;
  },
  HALF_WIDTH_TEXT_FIELD_CHARACTER_LIMIT: 14,
  CITY_STATION_TYPE: 'C',

  get ABORT_NEAREST_AIRPORTS_CALLS() {
    const timeInSeconds = 5;
    const timeInMS = timeInSeconds * 1000;
    return timeInMS;
  },
};
export default Constants;
